import AppService from './AppService';

class LocationService extends AppService {

  constructor() {
    super();
    this.path = this.getPath('locations');
  }

  create(data) {
    return this.http.post(`${this.path}`, data);
  }

  update(data, id) {
    return this.http.patch(`${this.path}/${id}`, data);
  }

  delete(id) {
    return this.http.delete(`${this.path}/${id}`);
  }

  read(id) {
    return this.http.get(`${this.path}/${id}`);
  }

  list(params = '') {
    const queryParams = params ? params : '';
    return this.http.get(`${this.path}${queryParams}`);
  }
}

export default LocationService;
